import { Suspense } from 'react';
import { createBrowserRouter, RouterProvider as ReactRouterProvider } from 'react-router-dom';

import { WorkspaceSkeleton } from '@/app/layouts';

import { routes } from './routes';

function RouteLoadingFallback() {
  return <WorkspaceSkeleton />;
}

let router: ReturnType<typeof createBrowserRouter> | undefined;

function getRouter(): ReturnType<typeof createBrowserRouter> {
  router ??= createBrowserRouter(routes);
  return router;
}

/**
 * Provides routing context to the application.
 * Wraps routes in Suspense for lazy-loaded page components.
 */
export function RouterProvider() {
  return (
    <Suspense fallback={<RouteLoadingFallback />}>
      <ReactRouterProvider router={getRouter()} />
    </Suspense>
  );
}
